import { useSyncExternalStore } from 'react';

let bodyStyleVersion = 0;
let observer: MutationObserver | null = null;
const listeners = new Set<() => void>();

const emit = () => {
  bodyStyleVersion += 1;
  listeners.forEach((listener) => listener());
};

const ensureObserver = () => {
  if (typeof window === 'undefined' || observer != null) {
    return;
  }

  observer = new MutationObserver(() => {
    emit();
  });

  observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  ensureObserver();

  return () => {
    listeners.delete(listener);

    if (listeners.size === 0 && observer != null) {
      observer.disconnect();
      observer = null;
    }
  };
};

const getSnapshot = () => bodyStyleVersion;

export const useBodyStyleVersion = () => {
  return useSyncExternalStore(subscribe, getSnapshot, () => 0);
};